import axios from 'axios';
import { clearAuthData } from './auth';

const CHATBOT_API_URL = import.meta.env.VITE_CHATBOT_API_URL || 'http://localhost:8001';

const chatbotClient = axios.create({
    baseURL: `${CHATBOT_API_URL}/api/v1`,
    headers: { 'Content-Type': 'application/json' },
});

chatbotClient.interceptors.request.use((config) => {
    const token = localStorage.getItem('access_token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

chatbotClient.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            clearAuthData();
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default chatbotClient;
export const CHATBOT_API_BASE = CHATBOT_API_URL;
